/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { appControllerHandleEvent } from '../fn/events/app-controller-handle-event';
import { appControllerHandleEvent_1 } from '../fn/events/app-controller-handle-event-1';
import { AppControllerHandleEvent_1$Params } from '../fn/events/app-controller-handle-event-1';
import { appControllerHandleEvent_2 } from '../fn/events/app-controller-handle-event-2';
import { AppControllerHandleEvent_2$Params } from '../fn/events/app-controller-handle-event-2';
import { appControllerHandleEvent_3 } from '../fn/events/app-controller-handle-event-3';
import { AppControllerHandleEvent_3$Params } from '../fn/events/app-controller-handle-event-3';
import { appControllerHandleEvent_4 } from '../fn/events/app-controller-handle-event-4';
import { AppControllerHandleEvent_4$Params } from '../fn/events/app-controller-handle-event-4';
import { appControllerHandleEvent_5 } from '../fn/events/app-controller-handle-event-5';
import { AppControllerHandleEvent_5$Params } from '../fn/events/app-controller-handle-event-5';
import { appControllerHandleEvent_6 } from '../fn/events/app-controller-handle-event-6';
import { AppControllerHandleEvent_6$Params } from '../fn/events/app-controller-handle-event-6';
import { appControllerHandleEvent_7 } from '../fn/events/app-controller-handle-event-7';
import { AppControllerHandleEvent_7$Params } from '../fn/events/app-controller-handle-event-7';
import { AppControllerHandleEvent$Params } from '../fn/events/app-controller-handle-event';
import { appControllerHealthCheck } from '../fn/events/app-controller-health-check';
import { AppControllerHealthCheck$Params } from '../fn/events/app-controller-health-check';

@Injectable({ providedIn: 'root' })
export class EventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appControllerHandleEvent()` */
  static readonly AppControllerHandleEventPath = '/thalea-clinics/events/handler';

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent$Response(params?: AppControllerHandleEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
    return appControllerHandleEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent(params?: AppControllerHandleEvent$Params, context?: HttpContext): Observable<{
'message'?: string;
}> {
    return this.appControllerHandleEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>): {
'message'?: string;
} => r.body)
    );
  }

  /** Path part for operation `appControllerHandleEvent_1()` */
  static readonly AppControllerHandleEvent_1Path = '/thalea-doctors/events/handler';

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_1$Response(params?: AppControllerHandleEvent_1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
    return appControllerHandleEvent_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_1(params?: AppControllerHandleEvent_1$Params, context?: HttpContext): Observable<{
'message'?: string;
}> {
    return this.appControllerHandleEvent_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>): {
'message'?: string;
} => r.body)
    );
  }

  /** Path part for operation `appControllerHandleEvent_2()` */
  static readonly AppControllerHandleEvent_2Path = '/thalea-documents/events/handler';

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_2$Response(params?: AppControllerHandleEvent_2$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
    return appControllerHandleEvent_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_2(params?: AppControllerHandleEvent_2$Params, context?: HttpContext): Observable<{
'message'?: string;
}> {
    return this.appControllerHandleEvent_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>): {
'message'?: string;
} => r.body)
    );
  }

  /** Path part for operation `appControllerHealthCheck()` */
  static readonly AppControllerHealthCheckPath = '/thalea-documents/events/health';

  /**
   * Health check.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHealthCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHealthCheck$Response(params?: AppControllerHealthCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appControllerHealthCheck(this.http, this.rootUrl, params, context);
  }

  /**
   * Health check.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHealthCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHealthCheck(params?: AppControllerHealthCheck$Params, context?: HttpContext): Observable<void> {
    return this.appControllerHealthCheck$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appControllerHandleEvent_3()` */
  static readonly AppControllerHandleEvent_3Path = '/thalea-google-events/events/handler';

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent_3()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_3$Response(params?: AppControllerHandleEvent_3$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
    return appControllerHandleEvent_3(this.http, this.rootUrl, params, context);
  }

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent_3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_3(params?: AppControllerHandleEvent_3$Params, context?: HttpContext): Observable<{
'message'?: string;
}> {
    return this.appControllerHandleEvent_3$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>): {
'message'?: string;
} => r.body)
    );
  }

  /** Path part for operation `appControllerHandleEvent_4()` */
  static readonly AppControllerHandleEvent_4Path = '/thalea-match/events/handler';

  /**
   * Handle SNS messages for entity synchronization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent_4()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_4$Response(params?: AppControllerHandleEvent_4$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appControllerHandleEvent_4(this.http, this.rootUrl, params, context);
  }

  /**
   * Handle SNS messages for entity synchronization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent_4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_4(params?: AppControllerHandleEvent_4$Params, context?: HttpContext): Observable<void> {
    return this.appControllerHandleEvent_4$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appControllerHandleEvent_5()` */
  static readonly AppControllerHandleEvent_5Path = '/thalea-pathways/events/handler';

  /**
   * Handle SNS messages for entity synchronization.
   *
   * Handles SNS messages for entity synchronization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent_5()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_5$Response(params?: AppControllerHandleEvent_5$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appControllerHandleEvent_5(this.http, this.rootUrl, params, context);
  }

  /**
   * Handle SNS messages for entity synchronization.
   *
   * Handles SNS messages for entity synchronization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent_5$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_5(params?: AppControllerHandleEvent_5$Params, context?: HttpContext): Observable<void> {
    return this.appControllerHandleEvent_5$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appControllerHandleEvent_6()` */
  static readonly AppControllerHandleEvent_6Path = '/thalea-patients/events/handler';

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent_6()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_6$Response(params?: AppControllerHandleEvent_6$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
    return appControllerHandleEvent_6(this.http, this.rootUrl, params, context);
  }

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent_6$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_6(params?: AppControllerHandleEvent_6$Params, context?: HttpContext): Observable<{
'message'?: string;
}> {
    return this.appControllerHandleEvent_6$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>): {
'message'?: string;
} => r.body)
    );
  }

  /** Path part for operation `appControllerHandleEvent_7()` */
  static readonly AppControllerHandleEvent_7Path = '/thalea-psychos/events/handler';

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent_7()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_7$Response(params?: AppControllerHandleEvent_7$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
}>> {
    return appControllerHandleEvent_7(this.http, this.rootUrl, params, context);
  }

  /**
   * Unified event handler.
   *
   * Handle all events from SNS topics and SQS queues
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent_7$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent_7(params?: AppControllerHandleEvent_7$Params, context?: HttpContext): Observable<{
'message'?: string;
}> {
    return this.appControllerHandleEvent_7$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
}>): {
'message'?: string;
} => r.body)
    );
  }

}
